
export default {
  middleware ({ $auth }) {
    $auth.options.redirect = false
  },
}
